/*
 * @Author: your name
 * @Date: 2021-06-03 09:24:47
 * @LastEditTime: 2021-09-15 14:10:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \admin\src\plugins\language\en.js
 */
module.exports = {
    Public: {
        chainError: 'This link is connected incorrectly, please check and relink',
        chainChange: 'Please switch manually on metamask',
        openError: 'Fail: Not Enough Draw Quota',
        more: 'View More',
        buy: 'Buy Now',
        editions: 'Editions',
        day: 'D.',
        hour: 'H.',
        min: 'M.',
        paySuccess: 'Payment successful'
    },
    Head: {
        menu: 'Menu',
        connect: 'Connect',
        close: 'Close'
    },
    Footer: {
        slogan: 'Art and fashion publishing platform based on blockchain technology.',
        contact: 'Contact Us',
        about: 'About',
        userAbout: 'User agreement',
        privacyAbout: 'User privacy policy'
    },
    Menu: {
        home: 'HOME',
        drops: 'DROPS',
        news: 'NEWS',
        bazaar: 'BAZAAR',
        discover: 'DISCOVER',
    },
    Index: {
        artBlindBox: 'ART BLIND BOX',
        artFragments: 'ART FRAGMENTS',
        subFragments: 'Disrupt the traditional art market',
        fragment1: 'An artwork is divided into NFT fragments',
        fragment2: 'Fragments can be combined into a complete NFT',
        fragment3: 'Every artwork has its own story',
        fragment4: 'Collect all the Fragments for complete NFTs artwork',
        fragment5: 'Gateway between the traditional art world and blockchain',
        token: 'NON-FUNGIBLE TOKEN',
        subToken: 'Create unique digital artworks with the power of blockchain',
        t1: 'Circulation',
        t2: 'Traceable',
        t3: 'Authentication',
        t4: 'Unique',
        t5: 'Digital',
        t6: 'Tamper-proof',
        subT1: 'Creating a convenient network for trading works based on the digital circulation scene',
        subT2: 'Track every artwork with blockchain time stamps.',
        subT3: 'Each work can be identified on the chain to view block information',
        subT4: 'One-of-a-kind artworks based on ERC-721.',
        subT5: 'Store crypto artworks on the blockchain.',
        subT6: 'Protect artworks with anti-tampering technology.',
        about: 'ABOUT US',
        about1: 'M Space is a blockchain-based distribution platform for NFT artworks.M Space focuses on releasing rare and exclusive NFT artworks to crypto-art lovers and collectors. We strive to transform art and fashion with its innovative artworks, as well as autonomous fan communities supported by DAO.',
        about2: 'M Space now has been successfully launched series of campaigns to promote NFT artworks, including but not limited to artworks by NFN Kalyan, Chad Knight, Peter Mohrbacher, Macomoroni. These top digital artists have a huge influence on both social media & NFT world and their works can be valued for more than ten thousand dollars per piece in the secondary market.',
    },
    Market: {
        title: 'BAZAAR',
        screen: {
            price: 'Price',
            popular: 'Popularity',
            onSale: 'Works for sale',
            sellOut: 'Sold-out works',
        },
        search: 'Search all creations',
        pay: 'Pay',
        confirm: 'Confirm',
        edition: 'Edition of',
        number: 'Number',
        payment: 'Payment',
        remaining: '{number} Remaining',
        tips: 'Whether to pay for the purchase',
        success: 'Payment successful The work has been issued to the work account'
    },
    drops: {
        preEndTime: 'Official Launch in',
        endTime: 'ENDS IN',
        draw: {
            title: 'RULES',
            rules: [
                'Wallet addresses that have logged into M space before the launch of the third blind box series (before April 13) with a cumulative spending amount ≥ 3000USDT can enjoy the following benefits:',
                '1. Get 1 free draw (only for long-term blind box)',
                '2. 10% off when choosing“10 consecutive draws” (only for long-term blind box)',
                'After the launch of the third Blind Box series (after April 13), the addresses that have logged into M Space with a cumulative recharge amount ≥ 3000USDT can enjoy the following benefits:',
                '1. 10% off when choosing “10 consecutive draws” (only for long-term blind box)'
            ]
        }
    },
    author: {
        works: 'Artwork',
        profile: 'Artist Profile',
    },
    user: {
        gender: 'gender',
        age: 'Age',
        edit: 'Edit Profile',
        logout: 'Logout',
        setName: 'Edit nickname with up to 6 characters',
        setGender: 'Choose your gender',
        setBirthday: 'Choose your birthday',
        setProfile: 'Edit your profile with up to 30 characters',
        setEmail: 'Please fill in your email address Save',
        save: 'Save',
        male: 'Male',
        female: 'Female',
        ownedQuantily: 'Owned quantily',
        mintedTime: 'Minted time',
        createTime: 'Listed time'
    }
}


// WEBPACK FOOTER //
// ./src/plugins/language/en.js